export default "__VITE_ASSET__yv2khOuQ__"